import dayjs from 'dayjs'

import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/it'

dayjs.locale('en')

export default (context, inject) => {
  context.$dayjs = dayjs
  inject('dayjs', dayjs)
}
